<!--
 * @Description: 试卷详情
 * @Author: PF
 * @Date: 2025-06-20 10:27:21
 * @LastEditors: PF
 * @LastEditTime: 2025-10-29 15:40:32
-->

<template>
    <el-dialog class="wp80 hp86" :model-value="visible" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">试卷回顾</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeDialog">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
  <!-- <el-dialog title="试卷回顾" :model-value="visible" class="wp80 hp86"
    style="display: flex;align-items: center;justify-content: center;" @close="closeDialog" append-to-body
    :close-on-click-modal="false"> -->
    <el-container class="mainBox flexBox">
      <el-main style="padding:0">
        <div class="leftBox" v-if='questionTypeList.length'>
          <div class="stContainer" v-for='(value, val) in questionTypeList' :key='val'>
            <div class="stItemBox">
              <el-divider content-position="left">
                <p style="font-size: 18px;font-weight: 500;margin-bottom: 15px;">{{ val + 1 | filterOrder }}.{{ value.name }}【得分为：{{ value.df || 0 }}分】</p>
              </el-divider>
              <div class="stBox" v-for='(item, index) in value.questions' :key='index' :id="'topic' + item.type + index">
                <div class="tiGan">
                  <span style="font-size: 18px;margin-right: 10px;">{{ index + 1 }}</span>
                    <!-- isRight 0错误,1正确 -->
                  <el-tag type="success" size="small" effect="dark" v-if="item.isRight" style="margin-right: 5px;">正确</el-tag>
                  <el-tag type="danger" size="small" effect="dark" v-else style="margin-right: 5px;">错误</el-tag>
                  <span style="margin-right: 5px;">({{ item.score || 0 }}分)</span>
                  <span v-html="item.title" class='titleBox' v-if="item.type != 6"></span>
                </div>
                <div v-if="item.type == 0 || item.type == 1">
                  <div class="redalist">
                    <div v-for="(opt, idx) in item.options" :key="idx"
                      style="display: flex;align-items:center;margin-bottom: 5px;line-height: 30px;">
                      {{ opt.key }}.
                      <span v-html="opt.value"></span>
                    </div>
                  </div>
                </div>
                <div>
                  <p>
                    <span class="bottom-tit answerBox">【学生答案】</span>
                    <span v-if="item.type == 2" style="font-size: 16px;">{{item.myAnswer=='正确'?'✔':'✖'}}</span>
                    <span v-else v-html="item.myAnswer"></span>
                  </p>
                  <p>
                    <span class="bottom-tit answerBox">【参考答案】</span>
                    <span v-if="item.type == 2" style="font-size: 16px;">{{item.answer=='正确'?'✔':'✖'}}</span>
                    <span v-else v-html="item.answer"></span>
                  </p>

                  <el-collapse style="border: none;" v-if='item.analysis' expand-icon-position="left">
                    <el-collapse-item >
                      <template #title="{ isActive }">
                        <div class="bottom-tit answerBox" style="font-size: 14px;">【解析】</div>
                      </template>
                      <!-- <template slot="title">
                        <div class="bottom-tit answerBox" style="font-size: 14px;">【解析】</div>
                      </template> -->
                      <div v-html="item.analysis" style="margin:10px 10px 10px 0"></div>
                    </el-collapse-item>
                  </el-collapse>
                  <div v-else>
                    <span class="bottom-tit answerBox">【解析】</span>
                    <span>无</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="height: 500px;">
          <el-empty description="暂无试题"></el-empty>
        </div>
      </el-main>
      <el-aside width="330px" style="background-color: #fff;padding: 0;margin-bottom: 0;margin-left: 10px;">
        <div class="bgray">
          <div class="sjzcItemBox">
            <div class="Group-item">
              <div>总分</div>
              <div>{{ paperDetail.total || 0 }}分</div>
            </div>
            <div class="Group-item">
              <div>得分</div>
              <div>{{ paperDetail.score || 0 }}分</div>
            </div>
            <div class="Group-item">
              <div>用时</div>
              <div>{{ paperDetail.shiChang || 0 }}分钟</div>
            </div>
            <div class="Group-item">
              <div>交卷时间</div>
              <div>{{ paperDetail.submitTime }}</div>
            </div>
          </div>
        </div>
        <div class="bgray" ref="rigthData">
          <div class="answer-sheet" :style="{ height: tableHeight }">
            <el-scrollbar style="height:100%">
              <div v-for="(item, index) in questionTypeList" :key="index">
                <div class="answer-sheet-title">{{ index + 1 | filterOrder }}.{{ item.name }}题</div>
                <div class="answer-sheet-item">
                  <div v-for="(el, i) in item.questions" :key="i" class="answer-sheet-num" @click="rollTopic(el, i)">
                    <!-- isRight 0错误,1正确 -->
                    <el-tag type="success" size="small" effect="dark" class="answer-sheet-tag" v-if="el.isRight">{{ i + 1 }}</el-tag>
                    <el-tag type="danger" size="small" effect="dark" class="answer-sheet-tag" v-else>{{ i + 1 }}</el-tag>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </el-aside>

    </el-container>
  </el-dialog>
</template>

<script>
import { actionPost } from '@/api/common.js'
export default {
  data() {
    return {
      stVisible: false,
      submitLoading: false,
      submitScoreLoading: false,
      paperDetail: {
        total: 0,
        score: 0,
        shiChang: 0,
        submitTime: '',
        type: 0,
      },
      questionTypeList: [],
      typeIndex: 0,
      questionIndex: 0,
      isShowCard: true,
      qlist: [],
      txfbList: [{
        number: 0,
        jdsl: 0,
        zdsl: 0,
        knsl: 0,
        everyScore: 0,
      }], //题型分布
      // 试题类型 0单选 1多选 2判断 3填空 4问答 5阅读理解
      types: [
        { value: '0', label: '单选' },
        { value: '1', label: '多选' },
        { value: '2', label: '判断' },
      ],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: {}
    },
  },
  created() {
    this.getPaper()
  },
  watch: {
    visible(val) {
      if (val) {
        this.typeIndex = 0
        this.getPaper()
      }
    }
  },
  filters: {
    filterOrder(val) {
      if (val == 1) return '一'
      if (val == 2) return '二'
      if (val == 3) return '三'
      if (val == 4) return '四'
      if (val == 5) return '五'
      if (val == 6) return '六'
      if (val == 7) return '七'
      if (val == 8) return '八'
      if (val == 9) return '九'
      if (val == 10) return '十'
      if (val == 11) return '十一'
      if (val == 12) return '十二'
      if (val == 13) return '十三'
    }
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit("update:visible", false);
    },
    getPaper() {
      this.paperDetail = {
        total: 0,
        score: this.row.score,
        shiChang: this.row.shiChang,
        submitTime: this.row.submitTime,
        type: Number(this.row.type)
      }
      this.questionTypeList = this.row.questions || []
      this.jiSuanZongFen()
    },
    jiSuanZongFen() {
      this.paperDetail.total = this.questionTypeList.reduce(function (acc, obj) {
        return acc + Number(obj.total);
      }, 0);
    },
    changeType(index, item) {
      this.typeIndex = index
    },

    goItem(val) {
      let dom = 'stItemBox' + val
      let top = this.$refs[dom][0].offsetTop - 100
      window.scrollTo({ top: top, behavior: 'smooth' })
    },
    submit() {
      let data = {
        examPaperId: this.row.id,
        typeStr: JSON.stringify(this.txfbList)
      }
      actionPost({ url: '/api/v2/jiaowu/question/addQuesionToPaperAuto', data: data }).then((res) => {
        this.getPaper()
      })
    },

    rollTopic(e, index) {
      const element = document.getElementById(`topic${e.type + index}`);
      if (element) {
          element.scrollIntoView({
              behavior: "smooth"  // 平滑滚动
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
.mainBox {
  height: 100%;
  color: #333;
}

.sjName {
  width: 850px;
  text-align: center;
  font-size: 25px;
  border: 1px solid #eee;
  padding: 10px 15px
}

.leftBox {
  padding: 15px;
  color: #666;
  font-size: 15px;
  line-height: 30px;
  border: 1px solid #eee;
}

.stTypeItem {
  margin-right: 20px;
  color: #B1B1B1;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
}

.currentType {
  border-bottom: solid 2px #1ba1e2;
  color: #666;
}

.stContainer {
  min-height: 500px;
}

.stItemBox .tiGan {
  line-height: 33px;
  margin-bottom: 15px;
}
.stBox + .stBox {
  border-top: 1px dashed #d9d9d9;
  padding-top: 10px;
}

.stScore {
  margin: 0 2px;
  /* border-bottom: 1px solid; */
  /* cursor: pointer; */
  color: #428bca;
}

.stScore:hover {
  color: red;
}

.stBox {
  font-size: 15px;
  padding: 0px 10px;
}

.answerBox {
  color: #2491fc !important;
  margin-left: -5px;
  font-weight: bold;
}

.questItemBox {
  background-color: #fbfdff;
  border-bottom: 1px dashed #c0ccda;
  padding: 10px 5px;
  margin: 0 -10px;
}

.questItemBox:last-child {
  border-bottom: none
}

.cquest {
  width: 850px;
  margin: 0 auto;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  padding: 20px 35px;
}

.redalist {
  min-height: 50px;
  /* display: flex;
  align-items: center; */
  font-size: 14px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.bottom-tit {
  font-size: 14px;
  color: #606266;
  font-weight: 700;
  margin-left: -5px;
}

.Group-item {
  height: 35px;
  border-radius: 5px;
  padding: 0 10px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Group-item + .Group-item {
  border-top: 1px dashed #d9d9d9;
}

.Group-item div:last-child {
  color: #999;
}

.youCe {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bgray {
  border-radius: 5px;
  overflow: hidden;
  font-size: 15px;
}

.sjzcItemBox {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 3px;
  border-top-right-radius: none;
  border-top-left-radius: none;
}


.stzcBox {
  height: 35px;
  line-height: 35px;
  color: #fff;
  background: #37B5F8;
  text-align: center;
}

.answerCardBox {
  position: fixed;
  bottom: 0px;
  right: 0;
  z-index: 1;
  width: 400px;
}

.question-navi-controller {
  width: 80px;
  text-align: center;
  background: #1ba1e2;
  position: relative;
  color: #FFF;
  top: 1px;
  font-size: 14px;
  border-radius: 4px 4px 0 0 !important;
  font-family: "微软雅黑";
  cursor: pointer;
  height: 33px;
  line-height: 33px;
}

.question-navi-content {
  padding: 15px 4px 15px 4px;
  border: 2px solid #1ba1e2;
  z-index: 1;
  background: rgb(255, 255, 255);
  width: 400px;
}

.question-navi-item {
  display: inline-block;
  height: 24px;
  width: 24px;
  background: rgb(239, 237, 237);
  margin: 3px;
  font-family: arial;
  text-align: center;
  line-height: 24px;
  color: #428bca;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
}

.question-navi-item:hover {
  color: #fff;
  background: #1ba1e2;
}
.answer-sheet {
  background-color: #fff;
  padding: 10px;
  margin: 10px auto;
  border: 1px solid #eee;
}

.answer-sheet-title {
  font-size: 15px;
  height: 20px;
  line-height: 20px;
}

.answer-sheet-item {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  margin-top: 10px;
}

.answer-sheet-num {
  background-color: #f9f9f9;
  margin: 5px;
  cursor: pointer;
}
.answer-sheet-tag {
  width: 30px;
  height: 30px;
  line-height: 30px;
  padding:0;
  text-align: center;
}

</style>
<style scoped>
.mainBox :deep(.el-collapse-item__header) {
  border-bottom: none !important;
}
.mainBox :deep(.el-collapse-item__arrow) {
  margin: 0
}

:deep(.el-dialog) {
  margin: 0px auto !important;
  height: 90%;
  overflow: auto;
}

:deep(.el-dialog) .el-dialog__body {
  height: calc(100% - 54px);
  overflow: auto;
}
</style>